<!-- NAV LAYOUT -->
<template>
  <div class="shellStyles">
    <v-navigation-drawer v-model="drawer" app :mini-variant.sync="mini">
      <v-list dense>
        <v-list-item class="px-2">
          <v-list-item-avatar tile>
            <v-img src="../assets/ets-bill-tracker-nav-big.png"></v-img>
            <!-- <v-icon title="Expand Toolbar">domain</v-icon> -->
          </v-list-item-avatar>
          <v-list-item-content class="noHover">
            <v-list-item-title class="text-uppercase"
              >Legislative Bill Tracker</v-list-item-title
            >
          </v-list-item-content>
          <v-list-item-icon>
            <v-btn icon @click.stop="mini = !mini" small>
              <v-icon title="Condense Toolbar">chevron_left</v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>
        <v-divider></v-divider>
        <div v-for="(item, key) in routes" :key="key">
          <v-list-item v-if="item.route" @click.stop :to="item.name" link>
            <v-list-item-icon>
              <v-tooltip v-if="mini" right>
                <template v-slot:activator="{ on }">
                  <v-badge
                    :value="!!item.badge"
                    bordered
                    overlap
                    :color="!!item.badgeColor ? item.badgeColor : item.color"
                    :content="item.badge"
                  >
                    <v-icon :color="item.color">{{ item.icon }}</v-icon>
                  </v-badge>
                </template>
                <span>{{ item.title }}</span>
              </v-tooltip>
              <span v-else>
                <v-badge
                  :value="!!item.badge"
                  bordered
                  :color="!!item.badgeColor ? item.badgeColor : item.color"
                  overlap
                  :content="item.badge"
                >
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-badge>
              </span>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
          <!-- List items with sub menu -->
          <v-list-group v-else no-action>
            <template v-slot:prependIcon>
              <v-badge
                :value="!!item.badge"
                bordered
                :color="!!item.badgeColor ? item.badgeColor : item.color"
                overlap
                :content="item.badge"
              >
                <v-icon :color="item.color">{{ item.icon }}</v-icon>
              </v-badge>
            </template>
            <template v-slot:activator>
              <!-- <v-list-item-content> -->
              <v-list-item-title> {{ item.title }}</v-list-item-title>
              <!-- </v-list-item-content> -->
            </template>
            <v-list-item
              class="pl-8"
              v-for="sub in item.subroutes"
              :key="sub.title"
              :to="sub.name"
              link
            >
              <v-list-item-icon>
                <v-icon :color="sub.color" :title="sub.title">{{
                  sub.icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="pl-0">{{
                sub.title
              }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app dark class="primary">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <v-icon v-if="!drawer" title="Show Toolbar">menu</v-icon>
        <v-icon v-if="drawer" title="Hide Toolbar">menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title class="headline text-uppercase">
        <span>Legislative&nbsp;</span>
        <span class="font-weight-light">
          Bill Tracker
          <span v-if="version" class="caption"
            >&nbsp;Version {{ version }}</span
          >
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <Signin></Signin>
    </v-app-bar>
  </div>
</template>

<!-- SCRIPTS -->
<script>
import { authComputed } from '@state/helpers'
import Signin from '@components/login/sign-in.vue'
import { get, sync, commit, call } from 'vuex-pathify'
export default {
  components: {
    Signin,
  },
  data() {
    return {
      drawer: null,
      mini: true,
      version: VUE_APP_VERSION,

      persistentNavRoutes: [
        { name: '/', title: 'Home', icon: 'home', route: true },
        // {
        //   name: 'about',
        //   title: 'About',
        //   icon: 'mdi-information-variant',
        //   route: true,
        // },
      ],
      loggedInNavRoutes: [
        {
          name: '/tracker',
          title: 'Bills',
          icon: 'mdi-view-list',
          route: true,
        },
      ],
      loggedOutNavRoutes: [],
      roleSpecificNavRoutes: [
        //*Subroute/Role example
        // {
        //   name: '',
        //   title: 'Subgroup Example',
        //   icon: 'mdi-ambulance',
        //   color: 'green',
        //   roles: ['Admin', 'User'],
        //   subroutes: [
        //     {
        //       name: '/subgroup/e1',
        //       title: 'Example1',
        //       icon: 'mdi-assistant',
        //       roles: ['Admin', 'User'],
        //     },
        //     {
        //       name: '/subgroup/e1/movies',
        //       title: 'Movies',
        //       icon: 'mdi-movie-roll',
        //       roles: ['Admin', 'User'],
        //     },
        //     {
        //       name: '/subgroup/e1/office',
        //       title: 'Office',
        //       icon: 'mdi-office-building',
        //       roles: ['Admin', 'User'],
        //     },
        //     {
        //       name: '/subgroup/e1/helpers',
        //       title: 'Helpers',
        //       icon: 'mdi-help-circle-outline',
        //       roles: ['User'],
        //     },
        //   ],
        // },
        {
          name: '/admin',
          title: 'Admin',
          icon: 'mdi-cog',
          route: true,
          roles: ['SuperUser'],
        },
      ],
      logOutRoutes: [
        { name: '/logout', title: 'Log Out', icon: 'lock_open', route: true },
      ],
      logInRoutes: [
        { name: '/login', title: 'Login', icon: 'lock', route: true },
      ],
    }
  },
  watch: {
    isLoggedIn(nval, oval) {
      if (nval && nval != oval) {
        var getNotifications = window.setInterval(() => {
          if (this.isLoggedIn) {
            this.loadNotifications()
          } else {
            clearInterval(getNotifications)
          }
        }, 30000)
        this.loadNotifications()
        if (this.$route?.query?.redirectFrom) {
          this.$router.push(this.$route.query.redirectFrom)
        } else if (this.$route.name != null) {
          this.$router.push({
            name: 'tracker',
          })
        }
      } else {
        clearInterval(getNotifications)
        if (this.$router.history.current.name != 'login') {
          this.$router.push({
            name: 'login',
            query: {
              redirectFrom: this.$router.history.current.path,
            },
          })
        }
      }
    },
  },
  computed: {
    ...authComputed,
    ...get('notification', [
      'notifications',
      'hasUnacknowledged',
      'unacknowledgedCount',
      'loading',
    ]),
    routes() {
      var routes = this.persistentNavRoutes.filter((r) => true)
      if (this.isLoggedIn) {
        routes = routes.concat(this.loggedInNavRoutes)
        let notifRoute = {
          name: '/notifications',
          title: 'Notifications',
          icon: this.hasUnacknowledged ? 'mdi-bell-ring' : 'mdi-bell',
          color: this.hasUnacknowledged ? 'green' : '',
          badgeColor: this.hasUnacknowledged ? 'green darken-2' : '',
          badge: this.unacknowledgedCount,
          route: true,
        }
        routes.push(notifRoute)
        if (this.userAdminAgencies.length > 0) {
          let agencyUser = {
            name: '/agency',
            title: 'Manage Agency',
            icon: 'icon-office-cog',
            route: true,
          }
          routes.push(agencyUser)
        }
        if (this.userRoles.length > 0) {
          this.roleSpecificNavRoutes.forEach((route) => {
            var routeMatch = route.roles.filter((r) =>
              this.userRoles.includes(r)
            )
            if (routeMatch.length > 0) {
              if (route.route) {
                routes.push(route)
              } else {
                let subroutes = []
                route.subroutes.forEach((sr) => {
                  var srMatch = sr.roles.filter((srr) =>
                    this.userRoles.includes(srr)
                  )
                  if (srMatch.length > 0) {
                    subroutes.push(sr)
                  }
                })
                route.subroutes = subroutes
                routes.push(route)
              }
            }
          })
        }
        routes = routes.concat(this.logOutRoutes)
      } else {
        routes = routes.concat(this.loggedOutNavRoutes)
        routes = routes.concat(this.logInRoutes)
      }
      return routes
    },
  },
  methods: {
    ...call('notification', ['loadNotifications']),
  },
}
</script>

<!-- STYLES -->
<style scoped>
/* /deep/ .v-badge .v-badge__badge {
  height: 16px;
  min-width: 16px;
  font-size: 10px;
  border-width: 1px;
  padding: 3px 5px;
}
/deep/ .v-badge--bordered .v-badge__badge::after {
  height: 16px;
  min-width: 16px;
  font-size: 10px;
  border-width: 1px;
  padding: 3px 5px;
} */
</style>
